export enum VideoEventType {
    videoStarted = "videoStarted",
    videoStopped = "videoStopped",
    videoPaused = "videoPaused",
    videoCompleted = "videoCompleted",
    videoSeek = "videoSeek",
    videoProgress = "videoProgress",
}